document.addEventListener('DOMContentLoaded', () => {
  const DURATION = 400;

  const animate = (details, isOpening) => {
    const answer = details.querySelector('.care-faq-answer');
    if (!answer || details.dataset.animating === 'true') return;
    details.dataset.animating = 'true';

    if (isOpening) {
      details.open = true;
      const height = answer.scrollHeight;
      answer.style.overflow = 'hidden';
      answer.style.maxHeight = '0';
      answer.style.opacity = '0';
      answer.style.transition = `max-height ${DURATION}ms ease, opacity ${DURATION}ms ease`;

      requestAnimationFrame(() => {
        answer.style.maxHeight = `${height}px`;
        answer.style.opacity = '1';
      });

      setTimeout(() => {
        answer.style.maxHeight = '';
        answer.style.overflow = '';
        answer.style.opacity = '';
        answer.style.transition = '';
        details.dataset.animating = 'false';
      }, DURATION);
    } else {
      const height = answer.scrollHeight;
      answer.style.overflow = 'hidden';
      answer.style.maxHeight = `${height}px`;
      answer.style.opacity = '1';
      answer.style.transition = `max-height ${DURATION}ms ease, opacity ${DURATION * 0.6}ms ease`;

      requestAnimationFrame(() => {
        answer.style.maxHeight = '0';
        answer.style.opacity = '0';
      });

      setTimeout(() => {
        details.open = false;
        answer.style.maxHeight = '';
        answer.style.overflow = '';
        answer.style.opacity = '';
        answer.style.transition = '';
        details.dataset.animating = 'false';
      }, DURATION);
    }
  };

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.care-faq-trigger');
    if (trigger) {
      e.preventDefault();
      const details = trigger.closest('details');
      if (details) {
        animate(details, !details.open);
        const faq = details.closest('.care-faq');
        if (faq) {
          setTimeout(() => {
            const btn = faq.querySelector('.care-faq-expand-btn');
            if (!btn) return;
            const allOpen = [...faq.querySelectorAll('details')].every((d) => d.open);
            const label = btn.querySelector('.care-faq-expand-label');
            if (label) label.textContent = allOpen ? btn.dataset.collapseText : btn.dataset.expandText;
          }, DURATION + 30);
        }
      }
      return;
    }

    const expandBtn = e.target.closest('.care-faq-expand-btn');
    if (expandBtn) {
      const faq = expandBtn.closest('.care-faq');
      if (!faq) return;

      const allDetails = [...faq.querySelectorAll('details')];
      const allOpen = allDetails.every((d) => d.open);

      for (const details of allDetails) {
        if (allOpen && details.open) animate(details, false);
        else if (!allOpen && !details.open) animate(details, true);
      }

      const label = expandBtn.querySelector('.care-faq-expand-label');
      if (label) label.textContent = allOpen ? expandBtn.dataset.expandText : expandBtn.dataset.collapseText;
    }
  });
});
